// https://medium.com/@madridserginho/angular-environments-inheritance-4423e6d6c99d
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { SiteConfigModel } from '../app/shared/models/config/site-config.model';

const aboutIcon: IconProp = ['fas', 'info'];
const athletesIcon: IconProp = ['fas', 'person'];
const athleticSbIcon: IconProp = ['fas', 'tv'];
const backIcon: IconProp = ['far', 'arrow-left'];
const cameraIcon: IconProp = ['far', 'camera'];
const calendarIcon: IconProp = ['fas', 'calendar'];
const closeIcon: IconProp = ['fas', 'close'];
const darkModeIcon: IconProp = ['far', 'moon'];
const downloadIcon: IconProp = ['far', 'download'];
const doorOpenIcon: IconProp = ['far', 'door-open'];
const eventsIcon: IconProp = ['fas', 'table-list'];
const externalLinkIcon: IconProp = ['far', 'external-link'];
const fieldAppIcon: IconProp = ['fas', 'mobile-screen-button'];
const filterIcon: IconProp = ['far', 'bars-filter'];
const followOffIcon: IconProp = ['fasr', 'star'];
const followOnIcon: IconProp = ['fass', 'star'];
const forwardIcon: IconProp = ['far', 'arrow-right'];
const globeIcon: IconProp = ['fal', 'globe'];
const helpIcon: IconProp = ['fas', 'question'];
const homeIcon: IconProp = ['fas', 'home'];
const imagesIcon: IconProp = ['fas', 'images'];
const lightModeIcon: IconProp = ['far', 'sun-bright'];
const liveIcon: IconProp = ['fas', 'wave-pulse'];
const locationIcon: IconProp = ['fas', 'location-dot'];
const loginIcon: IconProp = ['fas', 'circle-user'];
const mapIcon: IconProp = ['fal', 'map'];
const menuIcon: IconProp = ['fas', 'bars'];
const moreIcon: IconProp = ['far', 'ellipsis-h'];
const placeChangeDownIcon: IconProp = ['far', 'chevron-down'];
const placeChangeStaticIcon: IconProp = ['far', 'arrows-h'];
const placeChangeUpIcon: IconProp = ['far', 'chevron-up'];
const pricingIcon: IconProp = ['fas', 'tag'];
const protestIcon: IconProp = ['fas', 'triangle-exclamation'];
const recordIcon: IconProp = ['far', 'trophy-alt'];
const reportsIcon: IconProp = ['far', 'files'];
const reviewIcon: IconProp = ['far', 'eye'];
const scoresIcon: IconProp = ['fas', 'arrow-down-1-9'];
const searchIcon: IconProp = ['fas', 'search'];
const settingsIcon: IconProp = ['fas', 'gear'];
const shareIcon: IconProp = ['far', 'share-from-square']; // share, share-nodes, share-from-square, arrow-up-from-square
const shoppingCartIcon: IconProp = ['fas', 'shopping-cart'];
const sortDefaultIcon: IconProp = ['far', 'minus'];
const sortDownIcon: IconProp = ['far', 'arrow-down'];
const sortUpIcon: IconProp = ['far', 'arrow-up'];
const spinnerIcon: IconProp = ['fas', 'spinner'];
const teamsIcon: IconProp = ['fas', 'people-group'];
const timeStandardIcon: IconProp = ['far', 'watch'];
const uploadIcon: IconProp = ['fas', 'upload'];
const videoIcon: IconProp = ['fas', 'video'];

const global: {
  production: boolean;
  allowMeetListEnterpriseUrlRedirects: boolean;
  firebase: {
    apiKey: string;
    authDomain: string;
    databaseURL: string;
    projectId: string;
    storageBucket: string;
    messagingSenderId: string;
    appId: string;
  };
  anetAPIEndpoint: string;
  baseAPIEndpoint: string;
  cdnEndpoint: string;
  cdnSkinEndpoint: string;
  displayProfilePictures: boolean;
  fieldAppAPIEndpoint: string;
  firebaseEndpoint: string;
  searchEndpoint: string;
  elasticEndpoint: string;
  icons: {
    about: IconProp;
    athletes: IconProp;
    athleticSb: IconProp;
    back: IconProp;
    calendar: IconProp;
    camera: IconProp;
    close: IconProp;
    darkMode: IconProp;
    download: IconProp;
    doorOpen: IconProp;
    events: IconProp;
    externalLink: IconProp;
    filter: IconProp;
    fieldApp: IconProp;
    followOff: IconProp;
    followOn: IconProp;
    forward: IconProp;
    globe: IconProp;
    help: IconProp;
    home: IconProp;
    images: IconProp;
    lightMode: IconProp;
    live: IconProp;
    location: IconProp;
    login: IconProp;
    map: IconProp;
    menu: IconProp;
    more: IconProp;
    placeChangeDown: IconProp;
    placeChangeStatic: IconProp;
    placeChangeUp: IconProp;
    pricing: IconProp;
    record: IconProp;
    reports: IconProp;
    review: IconProp;
    scores: IconProp;
    search: IconProp;
    settings: IconProp;
    share: IconProp;
    shoppingCart: IconProp;
    sortDefault: IconProp;
    sortDown: IconProp;
    sortUp: IconProp;
    spinner: IconProp;
    protest: IconProp;
    teams: IconProp;
    timeStandard: IconProp;
    upload: IconProp;
    video: IconProp;
  };
  paginationQuantity: number;
  placeChangeIcons: { [key: string]: IconProp };
  breakpoints: {
    within: {
      xs: string;
      sm: string;
      md: string;
      lg: string;
      xl: string;
      xxl: string;
      xxxl: string;
    };
    above: {
      xs: string;
      sm: string;
      md: string;
      lg: string;
      xl: string;
      xxl: string;
      xxxl: string;
    };
    below: {
      xs: string;
      sm: string;
      md: string;
      lg: string;
      xl: string;
      xxl: string;
      xxxl: string;
    };
  };
  devMachineName: string;
  devSkinMachineName: string;
  siteNames: { [key: string]: string };
  siteLinks: { [key: string]: string };
  siteList: { link: string[]; machineName: string; name: string }[];
  typingTimeout: number; // milliseconds to wait before firing search
  nonDefaultLocales: string[];
} = {
  production: false,
  allowMeetListEnterpriseUrlRedirects: true,
  firebase: {
    // apiKey: 'AIzaSyAB64b3RZYVE2x_4wjC-IQbpMXAK1gt8Gc',
    // authDomain: 'wip-tmio.firebaseapp.com',
    // databaseURL: 'https://wip-tmio.firebaseio.com',
    // projectId: 'wip-tmio',
    // storageBucket: 'wip-tmio.appspot.com',
    // messagingSenderId: '202483196326',
    // appId: '1:202483196326:web:9c6fa46c69b7b9bed8ef67',
    apiKey: 'AIzaSyDzcmVVM-yGckIz8UXu00iWSO4C4ru8vwk',
    authDomain: 'trackmeet-io.firebaseapp.com',
    databaseURL: 'https://trackmeet-io.firebaseio.com',
    projectId: 'trackmeet-io',
    storageBucket: 'trackmeet-io.appspot.com',
    messagingSenderId: '202483196326',
    appId: '1:202483196326:web:9c6fa46c69b7b9bed8ef67',
  },
  anetAPIEndpoint: 'https://www.athletic.net/api',
  baseAPIEndpoint: 'https://api.athletic.live/api',
  cdnEndpoint: 'https://livestatic.athletic.net',
  cdnSkinEndpoint: 'https://alivestatic.athletic.net',
  displayProfilePictures: true,
  fieldAppAPIEndpoint: 'https://fieldappapi.athletic.live',
  firebaseEndpoint: 'https://trackmeet-io.firebaseio.com',
  searchEndpoint: 'https://athleticlive.blob.core.windows.net/$web',
  elasticEndpoint: 'https://search.athletic.live',
  icons: {
    about: aboutIcon,
    athletes: athletesIcon,
    athleticSb: athleticSbIcon,
    back: backIcon,
    calendar: calendarIcon,
    camera: cameraIcon,
    close: closeIcon,
    darkMode: darkModeIcon,
    download: downloadIcon,
    doorOpen: doorOpenIcon,
    events: eventsIcon,
    externalLink: externalLinkIcon,
    fieldApp: fieldAppIcon,
    filter: filterIcon,
    followOff: followOffIcon,
    followOn: followOnIcon,
    forward: forwardIcon,
    globe: globeIcon,
    help: helpIcon,
    home: homeIcon,
    images: imagesIcon,
    lightMode: lightModeIcon,
    live: liveIcon,
    location: locationIcon,
    login: loginIcon,
    map: mapIcon,
    menu: menuIcon,
    more: moreIcon,
    protest: protestIcon,
    placeChangeDown: placeChangeDownIcon,
    placeChangeStatic: placeChangeStaticIcon,
    placeChangeUp: placeChangeUpIcon,
    pricing: pricingIcon,
    record: recordIcon,
    reports: reportsIcon,
    review: reviewIcon,
    scores: scoresIcon,
    search: searchIcon,
    settings: settingsIcon,
    share: shareIcon,
    shoppingCart: shoppingCartIcon,
    sortDefault: sortDefaultIcon,
    sortDown: sortDownIcon,
    sortUp: sortUpIcon,
    spinner: spinnerIcon,
    teams: teamsIcon,
    timeStandard: timeStandardIcon,
    upload: uploadIcon,
    video: videoIcon,
  },
  paginationQuantity: 100,
  placeChangeIcons: {
    'pc-dn': placeChangeDownIcon,
    d: placeChangeDownIcon,
    'pc-nt': placeChangeStaticIcon,
    n: placeChangeStaticIcon,
    'pc-up': placeChangeUpIcon,
    u: placeChangeUpIcon,
  },
  breakpoints: {
    within: {
      xs: '(max-width: 575.98px)',
      sm: '(min-width: 576px) and (max-width: 767.98px)',
      md: '(min-width: 768px) and (max-width: 991.98px)',
      lg: '(min-width: 992px) and (max-width: 1199.98px)',
      xl: '(min-width: 1200px) and (max-width: 1399.98px)',
      xxl: '(min-width: 1400px) and (max-width: 1599.98px)',
      xxxl: '(min-width: 1600px)',
    },
    above: {
      xs: '',
      sm: '(min-width: 576px)',
      md: '(min-width: 768px)',
      lg: '(min-width: 992px)',
      xl: '(min-width: 1200px)',
      xxl: '(min-width: 1400px)',
      xxxl: '(min-width: 1600px)',
    },
    below: {
      xs: '(max-width: 575.98px)',
      sm: '(max-width: 767.98px)',
      md: '(max-width: 991.98px)',
      lg: '(max-width: 1199.98px)',
      xl: '(max-width: 1399.98px)',
      xxl: '(max-width: 1599.98px)',
      xxxl: '',
    },
  },
  // http://localhost:4567
  // https://new.anet.live
  siteNames: {},
  siteLinks: {},
  devMachineName: '',
  devSkinMachineName: '',
  siteList: [
    {
      link: ['https://results.twelve1running.com'],
      machineName: 'twelveone',
      name: '12:1 Running',
    },
    {
      link: ['https://live.2lraceservices.com'],
      machineName: '2lrs',
      name: '2L Race Services',
    },
    {
      link: ['https://live.417running.com'],
      machineName: '417running',
      name: '417Running',
    },
    {
      link: ['https://live.5northtiming.com'],
      machineName: '5north',
      name: '5 North Timing',
    },
    {
      link: ['https://live.802timing.com'],
      machineName: '802timing',
      name: '802 Timing',
    },
    {
      link: ['https://live.910athletics.com'],
      machineName: '910athletics',
      name: '910 Athletics',
    },
    {
      link: ['https://live.a2racemanagement.com'],
      machineName: 'a2rm',
      name: 'A2 Race Management',
    },
    {
      link: ['https://live.adetiming.com'],
      machineName: 'adetiming',
      name: 'ADE Timing',
    },
    {
      link: ['https://results.adkinstrak.com'],
      machineName: 'adkinstrak',
      name: 'AdkinsTrak',
    },
    {
      link: ['https://live.adkinstrakwest.com'],
      machineName: 'adkinswest',
      name: 'AdkinsTrak West',
    },
    {
      link: ['https://results.aatiming.com'],
      machineName: 'aatiming',
      name: 'All-American Timing',
    },
    {
      link: ['https://live.alphatiming.net'],
      machineName: 'alphatiming',
      name: 'Alpha Timing',
    },
    {
      link: ['https://armorytrack.live'], // https://results.armorytrack.com
      machineName: 'armory',
      name: 'Armory Track',
    },
    {
      link: ['https://atlantic.anet.live'],
      machineName: 'atlanticcoast',
      name: 'Atlantic Coast Timing',
    },
    {
      link: [
        'https://live.athletic.net',
        'http://192.168.1.160:4567',
        'http://192.168.1.39:4567',
        'http://localhost:4000',
        'http://localhost:4200',
        'https://new.anet.live',
        'http://localhost:4567',
      ], // ,  https://live.athletic.net // http://localhost:4567 // https://new.anet.live
      machineName: 'athleticlive',
      name: 'AthleticLIVE',
    },
    {
      link: ['https://live.athletictiming.net'], // https://live.athletictiming.net
      machineName: 'athletictiming',
      name: 'Athletic Timing',
    },
    {
      link: ['https://live.athletics.ca', 'http://162.243.63.17'],
      machineName: 'athletics_canada',
      name: 'Athletics Canada',
    },
    {
      link: ['https://athleticscanterbury.anet.live'],
      machineName: 'athleticscanterbury',
      name: 'Athletics Canterbury',
    },
    {
      link: ['https://live.athleticsmanitoba.com'],
      machineName: 'athletics_manitoba',
      name: 'Athletics Manitoba',
    },
    {
      link: ['https://athleticsnsw.anet.live'],
      machineName: 'athleticsnsw',
      name: 'Athletics NSW',
    },
    {
      link: ['https://athleticsontario.anet.live'],
      machineName: 'athleticsontario',
      name: 'Athletics Ontario',
    },
    {
      link: ['https://athleticsotago.anet.live'],
      machineName: 'athleticsotago',
      name: 'Athletics Otago',
    },
    {
      link: ['https://athleticswest.anet.live'],
      machineName: 'athleticswest',
      name: 'Athletics West Ltd',
    },
    {
      link: ['https://bwracingservices.anet.live'],
      machineName: 'bwracing',
      name: 'B&W Racing Services',
    },
    {
      link: ['https://live.calgarytrackcouncil.com'],
      machineName: 'calgarytrackcouncil',
      name: 'Calgary Track Council',
    },
    {
      link: ['https://live.badgerstatetiming.com'],
      machineName: 'badgerstate',
      name: 'Badger State Timing',
    },
    {
      link: ['https://baltcityschools.anet.live'],
      machineName: 'baltcity',
      name: 'Baltimore City Public Schools',
    },
    {
      link: ['https://bcps.anet.live'],
      machineName: 'baltcps',
      name: 'Baltimore County Public Schools',
    },
    {
      link: ['https://bataviatrack.anet.live'],
      machineName: 'batavia',
      name: 'Batavia Track and Field',
    },
    {
      link: ['https://beartoothtrack.anet.live'],
      machineName: 'beartoothtrack',
      name: 'Beartooth Track Association',
    },
    {
      link: ['https://live.brrm.com'],
      machineName: 'brrm',
      name: 'Big River Race Management',
    },
    {
      link: ['https://live.belllaptiming.com'],
      machineName: 'belllap',
      name: 'Bell Lap Timing',
    },
    {
      link: ['https://results.blacksquirreltiming.com'],
      machineName: 'blacksquirrel',
      name: 'Black Squirrel Timing',
    },
    {
      link: ['https://live.bloomfieldtiming.com'],
      machineName: 'bloomfield',
      name: 'Bloomfield Timing',
    },
    {
      link: ['https://live.bluefoxtiming.com'],
      machineName: 'bluefox',
      name: 'Blue Fox Timing',
    },
    {
      link: ['https://blueridgetiming.live'],
      machineName: 'blueridge',
      name: 'Blue Ridge Timing',
    },
    {
      link: ['https://bolttiming.anet.live'],
      machineName: 'bolttiming',
      name: 'Bolt Timing',
    },
    {
      link: ['https://bmc.anet.live'],
      machineName: 'britishmilersclub',
      name: "British Miler's Club",
    },
    {
      link: ['https://bucknellbison.anet.live'],
      machineName: 'bucknell',
      name: 'Bucknell University',
    },
    {
      link: ['https://buffaloridgetiming.anet.live'],
      machineName: 'buffalo',
      name: 'Buffalo Ridge Timing',
    },
    {
      link: ['https://live.bullseyerunning.com'],
      machineName: 'bullseye',
      name: 'Bullseye Running',
    },
    {
      link: ['https://results.caltiming.com', 'https://caltimingnew.anet.live'],
      machineName: 'caltiming',
      name: 'Cal Timing',
    },
    {
      link: ['https://cca.anet.live'],
      machineName: 'cca',
      name: 'Canyon Crest Academy',
    },
    {
      link: ['https://results.athletics.org.ky'],
      machineName: 'cayman',
      name: 'Cayman Athletics',
    },
    {
      link: ['https://championbychoice.net'],
      machineName: 'cbchoice',
      name: 'Champion by Choice Timing',
    },
    {
      link: ['https://results.charlotteflights.org'],
      machineName: 'charlotte',
      name: 'Charlotte Flights',
    },
    {
      link: ['https://live.chippedtiming.com'],
      machineName: 'chippedtiming',
      name: 'Chipped Timing',
    },
    {
      link: ['https://live.chttiming.com'],
      machineName: 'chttiming',
      name: 'CHT Timing',
    },
    {
      link: ['https://cnutfxc.anet.live'],
      machineName: 'cnutfx',
      name: 'CNU TFXC',
    },
    {
      link: ['https://cetiming.anet.live'],
      machineName: 'coloradoelite',
      name: 'Colorado Elite Timing',
    },
    {
      link: ['https://live.competitivetiming.com'],
      machineName: 'competitivetiming',
      name: 'Competitive Timing',
    },
    // {
    //     link: ['https://live.crescentcitytiming.com'],
    //     machineName: 'crescity',
    //     name: 'Crescent City Timing',
    // },
    {
      link: ['https://dakotatiming.anet.live', 'https://results.dakotatiming.com'],
      machineName: 'dakota',
      name: 'Dakota Timing',
    },
    {
      link: ['https://live.deltatiming.com'],
      machineName: 'delta',
      name: 'Delta Timing',
    },
    {
      link: ['https://denverathletics.anet.live'],
      machineName: 'denverathletics',
      name: 'Denver Athletics',
    },
    {
      link: ['https://live.dcracetiming.com', 'https://dctnew.anet.live'],
      machineName: 'dctiming',
      name: 'DC Timing',
    },
    {
      link: ['https://live.dlprotiming.org'],
      machineName: 'dlprotiming',
      name: 'DL Pro Timing',
    },
    {
      link: ['https://domoreraces.anet.live'],
      machineName: 'domoreraces',
      name: 'Do More Race Services',
    },
    {
      link: ['https://results.durhamstriders.com'],
      machineName: 'durham',
      name: 'Durham Striders',
    },
    {
      link: ['https://ellingtontiming.anet.live'],
      machineName: 'ellington',
      name: 'Ellington Timing',
    },
    {
      link: ['https://live.enduranceracetiming.com'],
      machineName: 'endurance',
      name: 'Endurance Race Timing',
    },
    {
      link: ['https://enduro.anet.live'],
      machineName: 'enduro',
      name: 'Enduro USA',
    },
    {
      link: ['https://live.fstiming.com', 'https://fairchildnew.anet.live'],
      machineName: 'fstiming',
      name: 'Fairchild Sports Timing',
    },
    {
      link: ['https://live.fastfinishresults.com'],
      machineName: 'ffr',
      name: 'Fast Finish Results',
    },
    {
      link: ['https://live.finallapracing.com'],
      machineName: 'flracing',
      name: 'Final Lap Racing',
    },
    {
      link: ['https://live.finallaptiminggroup.com'],
      machineName: 'finallap',
      name: 'Final Lap Timing Group',
    },
    {
      link: ['https://live.finishright.com'],
      machineName: 'finishright',
      name: 'Finish Right',
    },
    {
      link: ['https://results.firstlanetiming.com'],
      machineName: 'firstlane',
      name: 'First Lane Timing',
    },
    {
      link: ['https://firsttimeout.anet.live'],
      machineName: 'fto',
      name: 'First Time Out',
    },
    {
      link: ['https://live.flashresultstexas.com'],
      machineName: 'flashresultstexas',
      name: 'Flash Results Texas',
    },
    {
      link: ['https://live.fortistiming.co'],
      machineName: 'fortistiming',
      name: 'Fortis Timing',
    },
    {
      link: ['https://fat.live'],
      machineName: 'fulton',
      name: 'Fulton Accurate Timing',
    },
    {
      link: ['https://live.gigaruntechservices.com'],
      machineName: 'gigarun',
      name: 'Gigarun Technology Services',
    },
    {
      link: ['https://live.gingerbreadtiming.com'],
      machineName: 'gingerbread',
      name: 'Gingerbread Running Co.',
    },
    {
      link: ['https://results.thegoldmedaltiming.com'],
      machineName: 'goldmedal',
      name: 'Gold Medal Timing',
    },
    {
      link: ['https://results.grimestimes.net'],
      machineName: 'grimestimes',
      name: 'Grimes Times',
    },
    {
      link: ['https://results.grizzlypeaktiming.com'],
      machineName: 'grizzlypeak',
      name: 'Grizzly Peak Timing',
    },
    {
      link: ['https://live.happypacetiming.com'],
      machineName: 'happypacetiming',
      name: 'Happy Pace Timing',
    },
    {
      link: ['https://hartfordtiming.anet.live'],
      machineName: 'hartfordtiming',
      name: 'Hartford Timing',
    },
    // {
    //     link: ['https://results.fttiming.com'],
    //     machineName: 'fttiming',
    //     name: 'FT Timing',
    // },`
    {
      link: ['https://live.harrierrace.com'],
      machineName: 'harrier',
      name: 'Harrier Race Management',
    },
    {
      link: ['https://results.hnscats.org'],
      machineName: 'hnscats',
      name: 'Hartington-Newcastle Public Schools',
    },
    {
      link: ['https://live.herostiming.com'],
      machineName: 'heros',
      name: "Hero's Timing",
    },
    {
      link: ['https://live.highspeedtiming.com'],
      machineName: 'highspeed',
      name: 'High Speed Timing',
    },
    {
      link: ['https://iptt.anet.live', 'https://ipttnew.anet.live'],
      machineName: 'iptt',
      name: 'Illinois Prep Top Timing',
    },
    {
      link: ['https://irvinetiming.anet.live'],
      machineName: 'irvine',
      name: 'Irvine Timing',
    },
    {
      link: ['https://live.iatt.ca'],
      machineName: 'iatt',
      name: '"It\'s About Time" Timing',
    },
    {
      link: ['https://live.ic4atrack.com'],
      machineName: 'ic4a',
      name: 'IC4A Track',
    },
    {
      link: ['https://jmtiming.anet.live'],
      machineName: 'jmtiming',
      name: 'J & M Timing',
    },
    {
      link: ['https://live.jactiming.com'],
      machineName: 'jactiming',
      name: 'JAC Timing',
    },
    {
      link: ['https://live.jdlfasttrack.com'],
      machineName: 'jdl',
      name: 'JDL Fast Track',
    },
    {
      link: ['https://live.justfortrack.com'],
      machineName: 'justfortrack',
      name: 'Just For Track',
    },
    {
      link: ['https://live.jwtimingllc.com'],
      machineName: 'jwtiming',
      name: 'JW Timing',
    },
    // {
    //     link: ['https://results.k2timing.com'],
    //     machineName: 'k2timing',
    //     name: 'K2 Timing',
    // },
    {
      link: ['https://results.kandjtiming.com'],
      machineName: 'kjtiming',
      name: 'K&J Timing',
    },
    {
      link: ['https://kcrc.anet.live'],
      machineName: 'kcrc',
      name: 'KC Running Company',
    },
    {
      link: ['https://live.kauderresults.com'],
      machineName: 'kauder',
      name: 'Kauder Racing, LLC',
    },
    {
      link: ['https://ksdathletics.anet.live'],
      machineName: 'kent',
      name: 'Kent School District',
    },
    {
      link: ['https://live.kicktothefinish.com'],
      machineName: 'kttf',
      name: 'Kick To The Finish',
    },
    {
      link: ['https://live.knoxvilleyouthathletics.org'],
      machineName: 'kya',
      name: 'Knoxville Youth Athletics',
    },
    {
      link: ['https://kvtfoa.anet.live'],
      machineName: 'kvtfoa',
      name: 'KVT & FOA',
    },
    {
      link: ['https://lasttimeout.anet.live'],
      machineName: 'lto',
      name: 'Last Time Out',
    },
    {
      link: ['https://live.labtrackclub.com'],
      machineName: 'labtiming',
      name: 'LAB Timing',
    },
    {
      link: ['https://results.lakeshoreathleticservices.com'],
      machineName: 'lakeshore',
      name: 'Lakeshore Athletic Services',
    },
    {
      link: ['https://live.letsgorun.com'],
      machineName: 'letsgoruntiming',
      name: 'Lets Go Run Timing',
    },
    {
      link: ['https://lexicontiming.com'],
      machineName: 'lexicon',
      name: 'Lexicon Timing',
    },
    {
      link: ['https://lightspeedtiming.anet.live'],
      machineName: 'lightspeedtiming',
      name: 'Light-Speed Timing',
    },
    {
      link: ['https://laqresults.anet.live'],
      machineName: 'littleathleticsqld',
      name: 'Little Athletics Queensland',
    },
    {
      link: ['https://live.lttiming.com'],
      machineName: 'lttiming',
      name: 'LTtiming',
    },
    {
      link: ['https://results.mdtimingllc.com', 'https://mdtimingnew.anet.live'],
      machineName: 'mdtiming',
      name: 'M&D Timing LLC',
    },
    {
      link: ['https://mantronix.anet.live'],
      machineName: 'mantronix',
      name: 'Mantronix Sports',
    },
    {
      link: ['https://live.mastiming.net'],
      machineName: 'mastiming',
      name: 'MAStiming',
    },
    {
      link: ['https://matstiming.anet.live'],
      machineName: 'matstiming',
      name: 'MATS Timing',
    },
    // {
    //     link: ['https://live.mccororymeetmanagement.com'],
    //     machineName: 'm3timing',
    //     name: 'McCorory Meet Management',
    // },
    {
      link: ['https://mankatoeast.anet.live'],
      machineName: 'mankatoeast',
      name: 'Mankato East Timing',
    },
    {
      link: ['https://live.mentzertiming.com'],
      machineName: 'mentzer',
      name: 'Mentzer Timing',
    },
    {
      link: ['https://live.mercurytiming.com'],
      machineName: 'mercury',
      name: 'Mercury Timing Systems',
    },
    {
      link: ['https://metroleaguewa.anet.live'],
      machineName: 'metro',
      name: 'Metro League',
    },
    {
      link: ['https://live.michianatiming.com'],
      machineName: 'michiana',
      name: 'Michiana Timing',
    },
    {
      link: ['https://results.midsouthracetiming.com'],
      machineName: 'midsouth',
      name: 'Mid South Race Timing',
    },
    {
      link: ['https://mwt.live'],
      machineName: 'midwesttiming',
      name: 'Midwest Timing',
    },
    {
      link: ['https://results.millenniumrunning.com'],
      machineName: 'mill',
      name: 'Millennium Running',
    },
    {
      link: ['https://mocotiming.anet.live'],
      machineName: 'mocotiming',
      name: 'MoCo Timing',
    },
    {
      link: ['https://live.mofasttiming.com'],
      machineName: 'mofast',
      name: 'MoFast Timing',
    },
    {
      link: ['https://montiming.anet.live'],
      machineName: 'montiming',
      name: 'Monongalia Timing',
    },
    {
      link: ['https://live.mountaintiming.com'],
      machineName: 'mountaintiming',
      name: 'Mountain Timing Associates LLC',
    },
    {
      link: ['https://live.mstca.org'],
      machineName: 'mstca',
      name: 'MSTCA',
    },
    {
      link: ['https://live.nestiming.com'],
      machineName: 'nestiming',
      name: 'Northeast Sports Timing Service',
    },
    {
      link: ['https://live.newrivertiming.com'],
      machineName: 'newrivertiming',
      name: 'New River Timing Company',
    },
    {
      link: ['https://ntsg.anet.live'],
      machineName: 'ntsg',
      name: 'NT Sports Guys LLC',
    },
    {
      link: ['https://live.nts-timing.com', 'https://ntstimingnew.anet.live'],
      machineName: 'nts',
      name: 'NTS Timing',
    },
    {
      link: ['https://results.ntxtiming.com'],
      machineName: 'ntxtiming',
      name: 'NTX Timing',
    },
    {
      link: ['https://athleticsoceania.anet.live'],
      machineName: 'oceaniaathletics',
      name: 'Oceania Athletics',
    },
    {
      link: ['https://olympicsedgetiming.anet.live'],
      machineName: 'olympicsedge',
      name: 'Olympics Edge Timing',
    },
    {
      link: ['https://live.northstartiming.com'],
      machineName: 'northstar',
      name: 'North Star Timing, LLC',
    },
    {
      link: ['https://live.onyourmarkstiming.com'],
      machineName: 'onyourmarks',
      name: 'OnYourMarks Timing',
    },
    {
      link: ['https://onyourmarks.anet.live'],
      machineName: 'onyourmarkscol',
      name: 'On Your Marks Columbia',
    },
    {
      link: ['https://live.palatinepack.com', 'https://palatinenew.anet.live'],
      machineName: 'palatine',
      name: 'Palatine Pack Timing',
    },
    {
      link: ['https://live.pctiming.com'],
      machineName: 'pctiming',
      name: 'Paynes Corner Timing',
    },
    {
      link: ['https://anetlive.peakperformancetiming.com'],
      machineName: 'peakperf',
      name: 'Peak Performance Timing',
    },
    {
      link: ['https://results.pelladutchlive.com'],
      machineName: 'pellaschools',
      name: 'Pella Community School District',
    },
    {
      link: ['https://live.performancetiming.com'],
      machineName: 'performancetiming',
      name: 'Performance Timing',
    },
    {
      link: ['https://results.pfvperformance.net', 'https://pvpnew.anet.live', 'https://pfvnew.anet.live'],
      machineName: 'pfv',
      name: 'PFv Performance LLC',
    },
    {
      link: ['https://phototiming.anet.live'],
      machineName: 'phototiming',
      name: 'Phototiming.com',
    },
    {
      link: ['https://live.pierretiming.com'],
      machineName: 'pierretiming',
      name: 'Pierre Timing',
    },
    {
      link: ['https://live.pioneertiming.com'],
      machineName: 'pioneer',
      name: 'Pioneer Timing',
    },
    {
      link: ['https://live.piratetiming.com'],
      machineName: 'pirate',
      name: 'Pirate Timing',
    },
    // {
    //   link: ['https://live.pntfo.com'],
    //   machineName: 'pntfo',
    //   name: 'PNTFO',
    // },
    {
      link: ['https://prathletics.live'],
      machineName: 'prathletics',
      name: 'PR Athletics',
    },
    {
      link: ['https://live.portcitytiming.com'],
      machineName: 'pct',
      name: 'Port City Timing',
    },
    {
      link: ['https://precision.anet.live'],
      machineName: 'p1timing',
      name: 'Precision One Timing',
    },
    {
      link: ['https://live.prtime.tf'],
      machineName: 'premierresults',
      name: 'Premier Results and Timing',
    },
    {
      link: ['https://qldathletics.anet.live'],
      machineName: 'qld',
      name: 'Queensland Athletics',
    },
    {
      link: ['https://live.qwtiming.com'],
      machineName: 'qwtiming',
      name: 'QW Timing',
    },
    {
      link: ['https://live.racepenguin.com'],
      machineName: 'racepenguin',
      name: 'Race Penguin',
    },
    {
      link: ['https://racetheclocktiming.anet.live'],
      machineName: 'rtc',
      name: 'Race the Clock Timing',
    },
    {
      link: ['https://raceplaceevents.anet.live'],
      machineName: 'raceplaceevents',
      name: 'Race Place Events',
    },
    {
      link: ['https://racetimers.anet.live'],
      machineName: 'racetimers',
      name: 'Race Timers',
    },
    {
      link: ['https://rapidtiming.anet.live'],
      machineName: 'rapidtiming',
      name: 'Rapid Timing',
    },
    {
      link: ['https://live.reddirtrunning.com'],
      machineName: 'reddirt',
      name: 'Red Dirt Race Management',
    },
    {
      link: ['https://live.recordtiming.com'],
      machineName: 'recordtiming',
      name: 'Record Timing',
    },
    {
      link: ['https://live.rrtiming.com'],
      machineName: 'rhodes',
      name: 'Rhodes Race Timing',
    },
    {
      link: ['https://live.roadrunnerracetiming.com'],
      machineName: 'roadrunner',
      name: 'Roadrunner Race Timing',
    },
    {
      link: ['https://live.runfarusa.com', 'https://runfarnew.anet.live'],
      machineName: 'runfar',
      name: 'RunFAR Racing Services, Inc.',
    },
    {
      link: ['https://results.run-ne.com'],
      machineName: 'runnebraska',
      name: 'Run Nebraska',
    },
    {
      link: ['https://live.raceresultsplus.com', 'https://rivercitynew.anet.live'],
      machineName: 'rivercity',
      name: 'River City Race Management',
    },
    {
      link: ['https://results.run.tf'],
      machineName: 'runtf',
      name: 'RUN.tf',
    },
    {
      link: ['https://live.runaroundracing.com'],
      machineName: 'runaround',
      name: 'Runaround Racing',
    },
    {
      link: ['https://live.rtsracetiming.com'],
      machineName: 'rts',
      name: 'RTS Race Timing',
    },
    {
      link: ['https://live.sangertrackandfield.com'],
      machineName: 'sangertimes',
      name: 'Sanger Track and Field',
    },
    {
      link: ['https://scolessportstiming.anet.live'],
      machineName: 'scoles',
      name: 'Scoles Sports Timing',
    },
    {
      link: ['https://live.seotiming.com'],
      machineName: 'seotiming',
      name: 'SEO Timing',
    },
    {
      link: ['https://shannoneventtimings.anet.live'],
      machineName: 'shannon',
      name: 'Shannon Event Timings',
    },
    {
      link: ['https://results.shazamracing.com', 'https://shazamnew.anet.live'],
      machineName: 'shazam',
      name: 'ShaZam Racing',
    },
    {
      link: ['https://sheffieldathletics.anet.live'],
      machineName: 'sheffield',
      name: 'Sheffield Athletics Timing',
    },
    {
      link: ['https://smac.anet.live'],
      machineName: 'smac',
      name: 'Southern Maryland Athletic Conference',
    },
    {
      link: ['https://snapresults.snaptiming.com'],
      machineName: 'snaptiming',
      name: 'SnapTiming',
    },
    {
      link: ['https://live.snakerivertiming.com'],
      machineName: 'snakeriver',
      name: 'SnakeRiverTiming',
    },
    {
      link: ['https://live.sportmadesimple.com'],
      machineName: 'sportmadesimple',
      name: 'Sport Made Simple',
    },
    {
      link: ['https://live.sstresults.com'],
      machineName: 'sst',
      name: 'Speed Sport Timing',
    },
    {
      link: ['https://live.sbtiming.net'],
      machineName: 'speedingbullet',
      name: 'Speeding Bullet Timing',
    },
    {
      link: ['https://results.speedysneakers.com', 'https://speedysneakersnew.anet.live'],
      machineName: 'speedy',
      name: 'Speedy Sneakers Racing',
    },
    {
      link: ['https://results.stuartroadracing.com'],
      machineName: 'stuart',
      name: 'Stuart Road Racing LLC',
    },
    {
      link: ['https://live.sub4sports.com'],
      machineName: 'sub4sports',
      name: 'Sub4Sports',
    },
    {
      link: ['https://results.superiortiming.com'],
      machineName: 'superior',
      name: 'Superior Timing',
    },
    {
      link: ['https://swtiming.anet.live'],
      machineName: 'swtiming',
      name: 'SCW Enterprises',
    },
    {
      link: ['https://live.tdemingtiming.com'],
      machineName: 'tdeming',
      name: 'TDeming Timing',
    },
    {
      link: ['https://live.temporuntiming.com'],
      machineName: 'temporun',
      name: 'Tempo Run Timing',
    },
    {
      link: ['https://ottcenter.live'],
      machineName: 'ottcenter',
      name: 'Ott Center',
    },
    {
      link: ['https://results.ptgrouponline.com'],
      machineName: 'perfecttiming',
      name: 'The Perfect Timing Group',
    },
    {
      link: ['https://thundertiming.anet.live'],
      machineName: 'thunder',
      name: 'Thunder Timing',
    },
    {
      link: ['https://results.timingfirst.com'],
      machineName: 'timingfirst',
      name: 'Timing First',
    },
    {
      link: ['https://live.timingmd.net', 'https://timingmdnew.anet.live'],
      machineName: 'timingmd',
      name: 'TimingMD',
    },
    {
      link: ['https://live.timinginc.com'],
      machineName: 'timinginc',
      name: 'Timing Inc',
    },
    {
      link: ['https://live.timingking.com', 'https://timingkingnew.anet.live'],
      machineName: 'timingking',
      name: 'Timing King',
    },
    {
      link: ['https://live.tomahawktiming.com'],
      machineName: 'tomahawktiming',
      name: 'Tomahawk Timing',
    },
    {
      link: ['https://live.trackmactiming.com'],
      machineName: 'trackmac',
      name: 'Track Mac Timing',
    },
    {
      link: ['https://trackntime.anet.live'],
      machineName: 'trackntime',
      name: "Track 'n Time",
    },
    {
      link: ['https://live.trackqua.com'],
      machineName: 'trackqua',
      name: 'Trackqua',
    },
    {
      link: ['https://results.tracksidetiming.com'],
      machineName: 'tracksidetiming',
      name: 'Trackside Timing',
    },
    {
      link: ['https://results.trojantiming.com'],
      machineName: 'trojan',
      name: 'Trojan Timing',
    },
    {
      link: ['https://live.usp-sports.com'],
      machineName: 'usp',
      name: 'Ultimate Sports Productions',
    },
    {
      link: ['https://uwwtrack.anet.live'],
      machineName: 'uwwtrack',
      name: 'UW-Whitewater Track & Field',
    },
    {
      link: ['https://results.upstarttiming.com'],
      machineName: 'upstarttiming',
      name: 'UpStart Timing',
    },
    {
      link: ['https://usatforegon.anet.live'],
      machineName: 'usatfor',
      name: 'USATF Oregon',
    },
    // {
    //     link: ['https://results.vipertiming.com'],
    //     machineName: 'viper',
    //     name: 'Viper Timing',
    // },
    {
      link: ['https://results.vwmanage.com'],
      machineName: 'vwmgmt',
      name: 'VW Management Services',
    },
    {
      link: ['https://results.wayzatatiming.com', 'https://wayzatanew.anet.live'],
      machineName: 'wayzata',
      name: 'Wayzata Results',
    },
    {
      link: ['https://falconrelays.com'],
      machineName: 'falcon',
      name: 'WBND Falcon Relays',
    },
    {
      link: ['https://live.wmdtracktiming.com'],
      machineName: 'westernmd',
      name: 'Western Maryland F.A.T',
    },
    {
      link: ['https://live.westlaketiming.com'],
      machineName: 'westlake',
      name: 'Westlake Timing',
    },
    {
      link: ['https://live.westsidetiming.com'],
      machineName: 'westside',
      name: 'Westside Timing',
    },
    {
      link: ['https://results.windsorrunning.com'],
      machineName: 'windsorrunning',
      name: 'Windsor Running, LLC',
    },
    {
      link: ['https://live.windsortiming.com'],
      machineName: 'windsortiming',
      name: 'Windsor Timing',
    },
    {
      link: ['https://results.wingfootfinish.com'],
      machineName: 'wingfoot',
      name: 'Wingfoot Finish',
    },
    {
      link: ['https://wwstiming.com'],
      machineName: 'wwstiming',
      name: 'WWS Timing',
    },
    {
      link: ['https://live.xpresstiming.com'],
      machineName: 'xpress',
      name: 'Xpress Timing',
    },
  ],
  typingTimeout: 500,
  nonDefaultLocales: ['fr', 'es'],
};

global.siteList.forEach((site) => {
  global.siteNames[site.machineName] = site.name;
  global.siteLinks[site.machineName] = site.link[0];
});

export const ENVIRONMENT_GLOBAL = global;

export const SITE_CONFIG_GLOBAL: SiteConfigModel = new SiteConfigModel({
  aboutOneLiner: 'Get professional track and field results with AthleticLIVE',
  contactEmail: 'ben@athletic.net',
  elasticSearchIndex: 'trackmeetio_v2',
  esReportIndex: 'tmio_reports_v2',
  facebookAppId: '',
  facebookImage: '/images/social/facebook-card-square.jpg',
  facebookLink: 'https://www.facebook.com/Athletic.net',
  loadingImageUrl: '/images/sitelogo.svg',
  machineName: 'athleticlive',
  headerImageUrl: '/images/sitelogo.svg',
  primaryBaseUrl: 'https://live.athletic.net',
  primaryElasticSearchIndex: 'live_results',
  primaryMachineName: 'athleticlive',
  primarySite: true,
  providedBy: 'AthleticLIVE',
  sendGridApiEndpoint: 'https://api.sendgrid.com/v3',
  sendGridApiRecipients: '/contactdb/recipients',
  sideMenuImageUrl: '/images/sitelogo.svg',
  siteName: 'AthleticLIVE',
  siteTitleSuffix: 'AthleticLIVE',
  siteUrl: 'https://live.athletic.net',
  tagLine: 'AthleticLIVE - Real Time Results',
  twitterImage: '/images/social/twitter-card-square.jpg',
  twitterLink: 'https://twitter.com/AthleticDotNet',
  twitterUsername: '@AthleticDotNet',
});
